// extracted by css-extract-rspack-plugin
export default {"root":"root-Zm_wF","mask":"mask-j3g9v","sheet":"sheet-dULa9"};